import {Component, OnInit} from '@angular/core';
import {SideNavService} from '../layouts/side-menu/sidenav/sidenav.service';
import {AccountService} from '../account/account.service';
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {NgxSpinnerService} from 'ngx-spinner';
import {AuthService} from '../authentication/auth.service';
import {ClipboardService} from 'ngx-clipboard';
import {environment} from 'src/environments/environment';
import axios from 'axios';
import Cookies from "js-cookie";
import { hasPackagePermission } from '../authentication/package.permission';

@Component({
  selector: 'app-device-connectivity',
  templateUrl: './device-connectivity.component.html',
  styleUrls: ['./device-connectivity.component.css'],

})
export class DeviceConnectivityComponent implements OnInit {
  formConnectivity: FormGroup;
  searchTerm = '';
  index = '';
  isToggleOn: boolean = true;
  isAddNew: boolean = false;
  filterBtnEnable: boolean = false;
  isDropdownVisibleProtocol = false;
  isDropdownVisibleClientId = false;
  generateClick = false;
  selectedOption = '';
  accessKey: string = '';
  clientId = '';
  deviceData: any[] = [];
  viewToggle = false;
  userName = '';
  password = '';
  publishAcl: Array<object> = [];
  subscribeAcl: Array<object> = [];
  filterRows = [];
  isGenerate = false;
  p = 1;
  protocol = '';
  connectedProtocol = '';
  textCopy;
  deviceCount;
  isClientIdExists = false;
  clientIdArray = [];
  connectivityDetails;
  subscribe_acl;
  publish_acl;
  currentId;
  error;
  deviceId;
  editView = false;
  currentUsername;
  currentProtocol;
  deleteView = false;
  selectedGrantType;
  grantTypeDropDown = false;
  authoritiesArray = []
  editMqtt = false;
  editHttp = false;
  editHttpPassword = false
  currentGrantType;
  clientSecret;
  scope;
  authorities;
  selectProtocol;
  httpConnectivityLength
  mqttLength;
  mqttView = false;
  httpView = false
  httpPasswordView = false;
  authorityString;
  currentStatus;
  accessToken;
  isComplete = false;
  response
  aclFormat
  connectivityLength: any;
  hideGenerateButton = false
  grantType
  isFormValid = false
  currentGrantTypeView
  currentUser

  constructor(private sideNavService: SideNavService, private accountService: AccountService,
              private toaster: ToastrService, private spinner: NgxSpinnerService, private formBuilder: FormBuilder,
              private clipboardService: ClipboardService) {
  }

  ngOnInit() {
    this.formConnectivity = this.formBuilder.group({
      username: [null],
      client_id: [null, Validators.required],
      password: [null],
      connectivity: [null, Validators.required],
      publish_acl: [null],
      subscribe_acl: [null],
      client_secret: [null],
      grant_type: [null]
    },{ validators: this.atLeastOneAclValidator });
    if (hasPackagePermission('Protocol')) {
      this.protocols = ["MQTT", "HTTP/S"];
      this.newProtocols = ["ALL","MQTT", "HTTP/S"];
    } else {
      this.protocols = ["MQTT"];
      this.newProtocols = ["MQTT"];
    }
    this.formConnectivity.get('connectivity').valueChanges.subscribe((connectivity) => {
      this.updateValidation(connectivity)
    })
    this.spinner.show()
    this.getClientsWithProtocolAndDeviceCount()
    this.deviceCountEachConnectivity()
    this.aclFormat = ['[{"pattern": "D2S/SA/aaaaa",', '"max_qos": 1},', '{"pattern": "D2S/SA/wwwww",', '"max_qos": 1}]']
    this.currentUser = Cookies.get("ROLE")
    console.log(this.currentUser)
  }

  updateValidation(connectivity: string) {
    const userNameControl = this.formConnectivity.get('username');
    const passwordControl = this.formConnectivity.get('password');
    const publishControl = this.formConnectivity.get('publish_acl');
    const subscribeAclControl = this.formConnectivity.get('subscribe_acl');
    const clientSecretControl = this.formConnectivity.get('client_secret');
    const grantTypeControl = this.formConnectivity.get('grant_type');

    // Clear validators
    [
      userNameControl, passwordControl,
      publishControl, subscribeAclControl,
      clientSecretControl, grantTypeControl
    ].forEach(control => {
      control.clearValidators();
      control.updateValueAndValidity({ emitEvent: false });
    });

    if (connectivity === 'MQTT') {
      // username + password required
      userNameControl.setValidators([Validators.required]);
      passwordControl.setValidators([Validators.required]);

      // JSON validation but NOT required
      publishControl.setValidators([jsonValidator()]);
      subscribeAclControl.setValidators([jsonValidator()]);

      // Add form-level validator for at least one ACL
      this.formConnectivity.setValidators(this.atLeastOneAclValidator());
    } else {
      clientSecretControl.setValidators([Validators.required]);
      grantTypeControl.setValidators([Validators.required]);

      // Remove form-level validator
      this.formConnectivity.clearValidators();
    }

    this.formConnectivity.updateValueAndValidity();
  }


  atLeastOneAclValidator() {
  return (form: AbstractControl) => {
    const publishControl = form.get('publish_acl');
    const subscribeControl = form.get('subscribe_acl');

    const pub = publishControl.value;
    const sub = subscribeControl.value;

    // CASE: both empty → required error on both
    if (!pub && !sub) {
      publishControl.setErrors({ ...(publishControl.errors || {}), required: true });
      subscribeControl.setErrors({ ...(subscribeControl.errors || {}), required: true });
    } 
    else {
      // CASE: one is filled → remove only `required` error safely
      if (publishControl.errors && publishControl.errors.required) {
        const { required, ...otherErrors } = publishControl.errors;
        publishControl.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
      }

      if (subscribeControl.errors && subscribeControl.errors.required) {
        const { required, ...otherErrors } = subscribeControl.errors;
        subscribeControl.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
      }
    }

    return null; // mandatory for validator
  };
}





  protocols: string[] = ["MQTT", "HTTP/S"];
  newProtocols: string[] = ["MQTT", "HTTP/S"]
  grantTypeDropDownText: string[] = ["client_credentials"]

  toggleButton(row: any) {
  }

  isSideNavVisible() {
    return this.sideNavService.isSideNavVisible;
  }

  addNewCredential() {
    this.isAddNew = true;
    this.isGenerate = false;
  }

  showProtocol() {
    console.log(this.filterBtnEnable)
    this.filterBtnEnable = !this.filterBtnEnable;
  }

  isToggleDropDown() {
    this.isDropdownVisibleProtocol = !this.isDropdownVisibleProtocol;
  }

  isGrantTypeDropDown() {
    this.grantTypeDropDown = !this.grantTypeDropDown
  }

  isToggleClient() {
    this.isDropdownVisibleClientId = !this.isDropdownVisibleClientId;
  }

  updateProtocol(protocol: string): void {
    this.filterBtnEnable = true;
    if(protocol == "ALL"){
      this.protocol = ''
    }else{
      this.protocol = protocol;
    }
  }

  getConnectivity(data: string) {
    this.isDropdownVisibleProtocol = true
    this.selectedOption = data;
    this.isGenerate = false
  }

  selectGrantType(type) {
    console.log(type)
    this.grantTypeDropDown = true
    this.isGenerate = false
    // this.selectedGrantType = type
    if(this.editHttp){
      this.currentGrantTypeView = type
    }else{
      this.currentGrantType = type
    }
  }

  closeGeneratePopup() {
    this.isAddNew = false;
    this.formConnectivity.reset()
    this.hideGenerateButton = false
    this.editHttp = false
    this.editMqtt = false
  }

  createVmqAcl(data) {
    this.isGenerate = true
    let connectivityArray = {};
    if (this.formConnectivity.invalid || (!AuthService.hasNewUserAccess) || this.checkClientId()) {
      // this.isFormValid = true
      return;
    }
    this.spinner.show()
    const publishValue = JSON.parse(data.publish_acl)
    const subscribeValue = JSON.parse(data.subscribe_acl)
    this.publishAcl.push(publishValue)
    this.subscribeAcl.push(subscribeValue)
    if (data.connectivity == "MQTT") {
      connectivityArray = {
        username: data.username,
        client_id: data.client_id,
        password: data.password,
        publish_acl: publishValue,
        subscribe_acl: subscribeValue
      }
      this.accountService.createVmqAcl(connectivityArray).subscribe((response) => {
        this.clientId = response.content.client_id;
        this.spinner.hide()
        this.isAddNew = false;
        this.toaster.success(response.message);
        this.getClientsWithProtocolAndDeviceCount()
        this.deviceCountEachConnectivity()
        this.formConnectivity.reset()
      }, error => {
        this.spinner.hide()
        this.toaster.error('Something went wrong')
      }, () => {
        this.spinner.hide()
      })
    } else {
      connectivityArray = {
        client_secret: data.client_secret,
        scope: 'read,write,trust',
        grant_type: data.grant_type,
        authorities: [],
        client_id: data.client_id
      }
      this.accountService.createHttpAclAuth(connectivityArray).subscribe((response) => {
        this.clientId = response.content.client_id;
        this.toaster.success(response.message);
        this.getClientsWithProtocolAndDeviceCount()
        this.deviceCountEachConnectivity()
        if (response.content.grant_type == 'client_credentials') {
          this.getAccessToken(response.content.id)
          this.hideGenerateButton = true;
        } else if (response.content.grant_type == 'password') {
          this.closeGeneratePopup()
        }
      }, error => {
        this.spinner.hide()
        this.toaster.error('Something went wrong')
      }, () => {
        this.spinner.hide()
      })
    }
  }

  generateToggle() {
    if (this.selectedOption != "MQTT") {
      this.generateClick = true;
    } else {
      this.generateClick = true;

    }
  }

  getClientId(id) {
    this.accountService.clientId = id;
  }

  isToggleView(connectivity) {
    this.viewToggle = !this.viewToggle;
    if (connectivity.protocol == 'MQTT') {
      this.mqttView = true
    } else {
      this.httpView = true
    }
  }

  viewConnectionDetail(id) {
    this.spinner.show()
    this.currentId = id;
    this.connectivityDetails.forEach((connectivity) => {
      if (id == connectivity.data.id) {
        this.clientId = connectivity.clientId;
        this.selectProtocol = connectivity.protocol;
        if (this.selectProtocol == 'HTTP/S') {
          this.clientSecret = connectivity.data.client_secret
          this.currentGrantTypeView = connectivity.data.grant_type
          if (this.currentGrantTypeView == 'client_credentials') {
            this.getAccessToken(id)
          }
        } else if (this.selectProtocol == 'MQTT') {
          this.userName = connectivity.data.username
          this.password = connectivity.data.password
          this.publish_acl = connectivity.data.publish_acl ? JSON.stringify(connectivity.data.publish_acl) : ''
          this.subscribe_acl = connectivity.data.subscribe_acl ? JSON.stringify(connectivity.data.subscribe_acl) : ''
          this.spinner.hide()
        }
      }
    })
  }

  showFilterDevice() {
    const search = this.searchTerm.toLowerCase();
    const protocol = this.protocol.toLowerCase()
    if (this.searchTerm === '' && (this.protocol === '' || this.protocol === 'ALL')) {
      return this.connectivityDetails;
    } else if (this.protocol !== '' && this.searchTerm === '') {
      return this.filterRows = this.connectivityDetails.filter(row =>
        row.protocol.toLowerCase().includes(protocol))
    } else if (this.searchTerm !== '' && (this.protocol === '' || this.protocol === 'ALL')) {
      return this.filterRows = this.connectivityDetails.filter(row =>{
        if(row.clientId){
         return row.clientId.toLowerCase().includes(search)
        }
      })
        
    } else {
      return this.filterRows = this.connectivityDetails.filter(row =>{
       if(row.clientId && row.protocol){
          return row.clientId.toLowerCase().includes(search) && row.protocol.toLowerCase().includes(protocol)
        }
      })
    }
  }


  public pageChange(event: number): void {
    this.p = event;
  }

  copyText(input: any) {
    const inputFieldValue = document.getElementById(input) as HTMLInputElement
    inputFieldValue.select();

    try {
      this.clipboardService.copyFromContent(inputFieldValue.value);
      this.toaster.success('Text copied')
    } catch (err) {
      this.toaster.error(err)
    }
  }

  hasPermissionFor(feature: string): boolean {
    return hasPackagePermission(feature);
  }

  getClientsWithProtocolAndDeviceCount() {
    if (this.hasPermissionFor("Protocol")) {
      this.accountService.getClientsWithProtocolAndDeviceCount().subscribe((res) => {
        this.connectivityDetails = res.content;
        this.connectivityLength = res.content.length
        this.clientIdArray = res.content.map((client) => client.clientId);
        this.spinner.hide()
    
      });
    } else {
      this.accountService.getClientsWithProtocolAndDeviceCountAzureUser().subscribe((res) => {
        this.connectivityDetails = res.content;
        this.connectivityLength = res.content.length;
        this.clientIdArray = res.content.map((client) => client.clientId);
        this.spinner.hide();
      });
    }
  }

  deviceCountEachConnectivity() {
    this.accountService.getAllVmqAcl().subscribe((res) => {
      this.mqttLength = res.content.length
    })
    if (this.hasPermissionFor("Protocol")) {
      this.accountService.getAllHttpAcl().subscribe((response: any) => {
        this.httpConnectivityLength = response.content.length
      })
    }
  }

  checkClientId() {
    let currentClientId = document.getElementById('clientIdInput') as HTMLInputElement
    console.log(currentClientId.value)
    if (this.editMqtt == true || this.editHttp == true) {
      this.isClientIdExists = currentClientId.value !== this.clientId && this.clientIdArray.some((id) => id === currentClientId.value);
    } else {
      this.isClientIdExists = this.clientIdArray.some((id) => id === currentClientId.value);
    }
    return this.isClientIdExists
  }

  updateValue(data, id) {
    this.isGenerate = true
    let connectivityArray
    if (data.connectivity == 'MQTT') {
      this.editMqtt = true
    } else {
      this.editHttp = true
    }
    if (!this.formConnectivity.valid || (!AuthService.hasNewUserAccess) || this.checkClientId()) {
      console.log(this.formConnectivity)
      return;
    }
    this.spinner.show()
    if (data.connectivity == 'MQTT') {
      const publishValue = JSON.parse(data.publish_acl)
      const subscribeValue = JSON.parse(data.subscribe_acl)
      this.publishAcl.push(publishValue)
      this.subscribeAcl.push(subscribeValue)
      connectivityArray = {
        username: data.username,
        client_id: data.client_id,
        password: data.password,
        publish_acl: publishValue,
        subscribe_acl: subscribeValue
      }
      console.log(connectivityArray)
      this.accountService.updatedVernemq(id, connectivityArray).subscribe((result) => {
        this.spinner.hide()
        this.toaster.success('Successfully Updated');
        this.getClientsWithProtocolAndDeviceCount()
        this.deviceCountEachConnectivity();
        this.editMqtt = false
      }, error => {
        console.log('Error updating object details:', error);
        this.toaster.error(error.message)
      }, () => {
        this.spinner.hide()
      })
    } else {
      this.isGenerate = true;
      connectivityArray = {
        client_secret: data.client_secret,
        scope: 'read,write,trust',
        grant_type: this.currentGrantTypeView,
        authorities: [],
        client_id: data.client_id
      }
      if( this.currentGrantTypeView == 'client_credentials'){
        this.hideGenerateButton = true
      }
      this.accountService.updateHttpClient(connectivityArray, id).subscribe((res) => {
        this.spinner.hide()
        this.toaster.success('Successfully updated');
        this.getClientsWithProtocolAndDeviceCount()
        this.deviceCountEachConnectivity();
        if (res.content.grant_type == 'client_credentials') {
          this.getAccessToken(res.content.id)
        } else if (res.content.grant_type == 'password') {
          this.closeGeneratePopup()
        }
        // this.isGenerate = false
      }, error => {
        console.log('Error updating object details:', error);
        this.toaster.error(error.message)
      }, () => {
        this.spinner.hide()
      })
    }

  }


  deleteClientDetails() {
    this.spinner.show()
    if (this.selectProtocol == 'MQTT') {
      this.accountService.deleteVmqAcl(this.currentId).subscribe((response) => {
          this.getClientsWithProtocolAndDeviceCount()
          this.spinner.hide()
          this.toaster.success('Device successfully deleted')
          this.deleteView = false
          this.deviceCountEachConnectivity()
        },
        error => {
          this.deleteView = false
          console.error('Error removing object:', error);
          this.toaster.error(error.message)
        }
      );
    } else if (this.selectProtocol == 'HTTP/S') {
      this.accountService.deleteHttpClient(this.currentId).subscribe((response) => {
          this.getClientsWithProtocolAndDeviceCount()
          this.spinner.hide()
          this.toaster.success('Device successfully deleted')
          this.deleteView = false
          this.deviceCountEachConnectivity()
        },
        error => {
          this.deleteView = false
          console.error('Error removing object:', error);
          this.toaster.error(error.message)
        }
      );
    }

  }

  updateActionKey(id, status: boolean) {
    let connectivityProtocol
    let clientId
    this.connectivityDetails.forEach((connectivity) => {
      if (id == connectivity.data.id) {
        connectivityProtocol = connectivity.protocol
        clientId = connectivity.clientId
      }
    })
    if (connectivityProtocol == 'MQTT') {
      this.accountService.updateActionKey(clientId, status).subscribe((res) => {
      })
    } else {
      this.accountService.updateActionKeyHttp(id, status).subscribe((res) => {
        }
      )
    }
  }

  getAccessToken(id) {
    this.spinner.show()
    this.accountService.getAccessToken(id).subscribe((response) =>{
      this.response = response.content
      this.accessToken = response.content.access_token
    }, error => {
      this.spinner.hide()
      this.toaster.error('Something went wrong')
      this.accessToken = ''
      console.log(error)
    }, () => {
      this.spinner.hide()
    })
  }

  protectUserData(id, isProtect, protocol) {
    this.spinner.show()
    if (this.currentUser == 1 || isProtect === true) {
      console.log(this.currentUser)
      if (protocol == 'MQTT') {
        axios.put(
          environment.host + '/core/connectivity/mqtt-protect/' + id + '?isProtect=' + isProtect,
          {
            headers: {'Content-Type': 'application/json', Authorization: 'Bearer ' + AuthService.getAccessToken()}
          }
        ).then(response => {
            this.getClientsWithProtocolAndDeviceCount()
            this.spinner.hide()
          })
      } else if (protocol == 'HTTP/S') {
        axios.put(environment.host + '/core/connectivity/http-protect/' + id + '?isProtect=' + isProtect,
          {
            headers: {'Content-Type': 'application/json', Authorization: 'Bearer ' + AuthService.getAccessToken()}
          }
        ).then(response => {
            this.spinner.hide()
            this.getClientsWithProtocolAndDeviceCount()
          }).catch(error => {
          this.spinner.hide()
        })
      } else {
        this.spinner.hide()
        this.toaster.error("You Can't Unlock the Data")
      }
    } else {
      this.spinner.hide()
      this.toaster.error("You Can't Unlock the Data")
    }
  }

}


function jsonValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const input = control.value;
    try {
      const jsonObjects = JSON.parse(input);
      return null; // All objects are valid JSON
    } catch (error) {
      return {invalidJson: true}; // Invalid JSON or syntax error
    }
  };
}
